export const setCalloriesNorm = (data) => {
  return {
    type: 'SET_CALLORIES_NORM',
    data,
  };
};

export const setExceptCategories = (data) => {
  return {
    type: 'SET_EXCEPT_CATEGORIES',
    data,
  };
};

export const setDayTabSelect = (data) => {
  return {
    type: 'SET_DAY_TAB_SELECTED',
    data,
  };
};



// WEBPACK FOOTER //
// ./src/actions/setParams.js